// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".taskBody{padding:12px;padding-top:8px;padding-bottom:24px}.taskBodyTitle{font-size:14px;font-weight:600;margin-bottom:12px;color:#666}.taskBodyToggle{font-size:14px;font-weight:600;color:#666}.taskBodyRow{display:flex;align-items:center;flex-wrap:wrap;margin-right:-12px}.taskBodyInput{margin-right:12px;margin-bottom:4px !important}.taskBodyInput.checkbox{margin-top:12px;margin-bottom:0px !important;margin-right:24px}\n", ""]);
// Exports
module.exports = exports;
